import React, { Component } from 'react';
import ScrollToTop from './ScrollToTop';
import NavBar from './NavBar';

class ProjectPage extends Component {
  render() {
    return (
    <div className="project-page">

      <NavBar/>
      <ScrollToTop/>

      <div className="project-banner" style={{backgroundImage:`url(${this.props.banner}`}}>
        <h2>{this.props.title}</h2>
      </div>

      <div className="project-page-container">
        <div className="page-container">

          {this.props.children}

        </div>
      </div>

    </div>
    );
  }
}

export default ProjectPage;